import { isNone } from '@ember/utils';

import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';

import Serializer from 'umg-ember-backend/serializers/application';

let relationshipKeys = [
  'headerArtistCustomLogo',
  'backgroundImage',
  'backgroundVideo',
  'footerLinks',
];

export default class MlpSerializer extends Serializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    pages: { embedded: 'always' },
    ownedByChannel: 'ownedByChannelId',
    isPreview: 'preview',
  };

  normalize(_model, hash) {
    // If options are available move relations from options to model
    if (!isNone(hash.options)) {
      relationshipKeys.forEach((key) => {
        this.moveRelationship(key, hash.options, hash);
      });

      try {
        const fontFamiliesToLoad = JSON.parse(hash.options.fontFamiliesToLoad);
        hash.options.fontFamiliesToLoad = Array.isArray(fontFamiliesToLoad)
          ? fontFamiliesToLoad
          : [];
      } catch {
        hash.options.fontFamiliesToLoad = [];
      }
    }

    return super.normalize(...arguments);
  }

  serialize() {
    let json = super.serialize(...arguments);

    // move relations from model to options
    relationshipKeys.forEach((key) => {
      this.moveRelationship(key, json, json.options);
    });

    if (json.options.fontFamiliesToLoad) {
      json.options = {
        ...json.options,
        fontFamiliesToLoad: JSON.stringify(json.options.fontFamiliesToLoad),
      };
    }

    // Check if options are set, otherwise set to null
    let notEmpty = Object.keys(json.options).some((key) => {
      return json.options[key] !== null;
    });

    if (!notEmpty) {
      json.options = null;
    }

    return json;
  }
}
